import config from "./Config.json"

export function GetApiConnection() {
  var apiConnection = "";

  switch (config.RunMode) {
    case "LOCAL":
      apiConnection = config.ApiUrlLocal;
      break;
    case "TEST":
      apiConnection = config.ApiUrlTest;
      break;
    case "LIVE":
      apiConnection = config.ApiUrl;
      break;
    default:
      apiConnection = "";
      break;
  }

  return apiConnection;
}